// components/ValuePropositionSection.js
import React, { useState } from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import CommonPopup from '../../PopupForm/CommonPopup';
import * as Yup from 'yup';

const ValuePropositionSection = ({title=null}) => {
    
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };
    
    const closeModal = () => {
        setIsModalOpen(false);
    };

    const PointsData = 
    [
        {
            id: 1,
            point: "KOL Panel of 7000+ experts",
        },
        {
            id: 2,
            point: "30+ Years of Primary Research Experience",
        },
        {
            id: 3,
            point: "20+ Geographies Covered",
        },
        {
            id: 4,
            point: "Expertise in Pharma, Biotech, and MedTech",
        },
        {
            id: 5,
            point: "Efficient Quantitative and Qualitative data analysis techniques",
        },
        {
            id: 6,
            point: "Highly qualified team of primary research analysts",
        }
    ]

    const options = {
        btn_name: "Submit"
      }
      const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/
    
      const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'
        
        },
        {
            name: 'company_name',
            label: '',
            placeholder: 'Company Name',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
          name: 'phone',
          label: '',
          placeholder: 'Phone Number',
          validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
          customClass: 'md:col-span-6 col-span-12'
        }
      ];
    return (
        <div id="ValueProposition">
            <section className="w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 lg:col-span-6">
                        <Image 
                            priority={false} 
                            width={2000} 
                            height={2000} 
                            src={process.env.IMG_CDN+'img/primary-research/Our-Value-Propositions-1.png'}
                            className="hidden w-full h-full lg:block"  
                            alt="our Values" 
                        />
                    </div>
                    <div className="col-span-12 lg:col-span-6">
                        {(title) &&
                            <SectionHeading 
                                title={title}
                                
                                customClass="text-center lg:text-left"
                            />
                        }
                        {PointsData?.map((item) => (
                            <div key={item.id} className="py-1">
                                <span className="pr-10 fa fa-check" style={{ color: '#2177e9' }}></span>
                                {item.point}
                            </div>
                        ))}
                        <div className="text-center md:text-left">
                            <button onClick={openModal} className="px-4 py-2 mt-4 text-white bg-blue-500 rounded hover:bg-blue-600">
                                Request For Call
                            </button>
                            <CommonPopup isOpen={isModalOpen} closeModal={closeModal} 
                                fields={fields}
                                options={options}
                                page_name="Primary Research Page"
                                form_name="primary-res-page-form"
                                formTitle="Request For Call"
                                endpoint="/enquiry/request-for-call"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ValuePropositionSection;
